<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <card-header :title="title" :icon="icon" color="primary" variant="gradient"></card-header>
          <v-card-text>
            <v-row>
              <v-col v-for="(field, index) in fields" :key="index" :cols="field.size">
                <template v-if="field.type === 'datepicker'">
                  <v-menu v-model="datePickerMenus[field.key]" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="localConditions[field.key]" :label="field.label"
                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="localConditions[field.key]"
                      @input="datePickerMenus[field.key] = false"></v-date-picker>
                  </v-menu>
                </template>

                <template v-if="field.type === 'text'">
                  <v-text-field v-model="localConditions[field.key]" :label="field.label"
                    :prepend-icon="field.icon"></v-text-field>
                </template>

                <template v-if="field.type === 'select'">
                  <v-select v-model="localConditions[field.key]" :label="field.label" :prepend-icon="field.icon"
                    :items="field.options" dense></v-select>
                </template>
              </v-col>
            </v-row>
            <slot name="buttons"></slot>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CardHeader from '@/components/cards/CardHeader.vue';

  export default {
    components: {
      CardHeader,
    },
    props: {
      title: String,
      fields: {
        type: Array,
        required: false,
      },
      value: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        icon: "mdi-magnify",
        localConditions: { ...this.value },
        datePickerMenus: {}, // DatePicker 상태 관리
      };
    },
    watch: {
      localConditions: {
        deep: true,
        handler(newVal) {
          this.$emit("input", newVal);
        },
      },
    },
  };
</script>

<style scoped></style>
